var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$vuetify.breakpoint.smAndUp)?_c('div',{staticClass:"flex-shrink-0 flex-grow-0 d-flex flex-column"},[_vm._t("default")],2):_c('v-navigation-drawer',{attrs:{"color":"cardBg","value":_vm.isOpen,"absolute":"","temporary":""},on:{"input":function($event){return _vm.$emit('update:is-open', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }